import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import * as Archiviazione from '../';
import { ApplicationState, strings } from '../..';
import { Column, DataTable, getIconName } from '../../core';
import { datetimeFormatter } from '../../core/utility';
import { Archivio } from '../models';
import ArchiviMobile from './ArchiviMobile';
import { mediaStyles, MediaContextProvider, Media } from '../../core'; 

const connector = connect(
    (state: ApplicationState) => ({ 
        archivi: state.archivi.archivi, 
        lingua: state.core.lingua,
    }),
    Archiviazione.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type ArchiviProps = PropsFromRedux
type ArchiviState = { page: number }

class Archivi extends React.Component<ArchiviProps, ArchiviState> {
    constructor(props: ArchiviProps) {
        super(props);

        this.state = {
            page: 1
        };
    }

    componentDidUpdate(_: Readonly<ArchiviProps>, statePrecedente: Readonly<ArchiviState>) {
        if (this.state.page !== statePrecedente.page) {
            this.props.loadArchivi(this.state);

            window.scrollTo(0, 0);
        }
    }

    render() {
        return (
            <div>
                <style>{mediaStyles}</style>
                <MediaContextProvider>
                    <Media greaterThanOrEqual="tablet">
                        <DataTable<Archivio>
                            dataSource={this.props.archivi.lista}
                            columns={this.createDataTableColumns()}
                            page={this.state.page}
                            itemsCount={this.props.archivi.itemsCount}
                            pageSize={this.props.archivi.pageSize}
                            primaryKey="idArchivio"
                            onPageChanged={this.onPageChanged}
                        />
                    </Media>
                    <Media at="mobile">
                        <ArchiviMobile 
                            archivi={this.props.archivi.lista}
                            page={this.state.page}
                            itemsCount={this.props.archivi.itemsCount}
                            pageSize={this.props.archivi.pageSize}
                            onPageChanged={this.onPageChanged}
                            backOnTopText={strings.core.dataTable.tornaSu}
                            onFileClick={this.onFileClick}
                        />
                    </Media>
                </MediaContextProvider>
            </div>
        );
    }

    createDataTableColumns = (): ReadonlyArray<Column<Archivio>> => {
        return [
            { key: 'tipoDocumento', label: strings.archivi.dataTable.tipoDocumento, width: 8 }, 
            { key: 'numeroProtocollo', label: strings.archivi.dataTable.numeroProtocollo }, 
            { key: 'dataProtocollo', label: strings.archivi.dataTable.dataProtocollo, formatter: datetimeFormatter }, 
            { key: 'sezionale', label: strings.archivi.dataTable.sezionale },
            { key: 'fileName', label: '', formatter: this.formatoDocumentoFormatter, width: 1 }
        ];
    }

    formatoDocumentoFormatter = (value: any, item: Archivio) => {
        const icon = getIconName(String(value));

        return (
            <Icon size='large' link name={icon.name} color={icon.color} onClick={this.onFileClick} id={item.idArchivio} />
        );
    }

    onFileClick = (_: any, data: any) => {
        this.props.downloadFile(String(data.id));
    }

    onPageChanged = (page: number) => {
        this.setState({ page });
    }
}

export default connector(Archivi);